var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
class ExpAdapterMiddleware {
  static applySettings(settings) {
    try {
      let url = settings.url || "";
      if (EnvironmentService.isUnifiedView) {
        let originalHostUrl = new URL(url).origin;
        let adapterHostUrl = EnvironmentService.endpoints.expmanAdapter.url.replace(/\/$/, "");
        url = url.replace(originalHostUrl, adapterHostUrl);
      }
      return Promise.resolve(__spreadProps(__spreadValues({}, settings), { url }));
    } catch (e) {
      return Promise.resolve(settings);
    }
  }
  static getMiddleware() {
    return (settings, next) => __async(this, null, function* () {
      const newSettings = yield this.applySettings(settings);
      return next(newSettings);
    });
  }
}
function expAdapterService() {
  return (constructor) => {
    const nc = class extends constructor {
      constructor(...args) {
        super(...args);
        this.addMiddleWare(ExpAdapterMiddleware.getMiddleware());
      }
    };
    return nc;
  };
}
export {
  ExpAdapterMiddleware,
  expAdapterService
};
//# sourceMappingURL=ExpAdapterMiddleware.js.map
